const translations = {
  'Favorite team': {
    en: 'Favorite team',
    es: 'Equipo favorito',
    pt: 'Time favorito',
  },
  'Matches of': {
    en: 'Matches of',
    es: 'Partidos de',
    pt: 'Jogos de',
  },
  'All matches': {
    en: 'All matches',
    es: 'Todos los partidos',
    pt: 'Todos os jogos',
  },
  'All tournaments': {
    en: 'All tournaments',
    es: 'Todos los torneos',
    pt: 'Todos os torneios',
  },
  'Live matches': {
    en: 'Live matches',
    es: 'Partidos en vivo',
    pt: 'Jogos ao vivo',
  },
  'Calendar': {
    en: 'Calendar',
    es: 'Calendario',
    pt: 'Calendário',
  },
  'There are no events available': {
    en: 'There are no events available',
    es: 'No hay eventos disponibles',
    pt: 'Não há eventos disponíveis',
  },
  'You can try selecting another tournament/dates or waiting for the dates to be programmed': {
    en: 'You can try selecting another tournament/dates or waiting for the dates to be programmed',
    es: 'Puedes intentar seleccionar otro torneo/fechas o esperar a que se programen las fechas',
    pt: 'Você pode tentar selecionar outro torneio/datas ou esperar que as datas sejam programadas',
  },
  'Week': {
    en: 'Week',
    es: 'Semana',
    pt: 'Semana',
  },
  'Add favorite team': {
    en: 'Add favorite team',
    es: 'Agregar equipo favorito',
    pt: 'Adicionar time favorito',
  },
  "You don't have a favorite team yet. Choose one and don't miss any match.": {
    en: "You don't have a favorite team yet. Choose one and don't miss any match.",
    es: 'Aun no tienes equipo favorito, elige uno y no te pierdas ni un partido.',
    pt: 'Voce ainda nao tem um time favorito, escolha um e nao perca nenhuma partida.',
  },
}

export default translations